// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"2b73acb6","144":"635e3293","155":"db6b753f","243":"c186d20e","485":"545a32b2","511":"f7229e93","522":"2362d2cb","643":"ed5df41a","761":"6ad06a88","821":"3cea64de","827":"912ee216","879":"413a3dae","974":"2b27e3eb","982":"112632a1","988":"aef06c6b"}[chunkId] + ".chunk.js";
};